import { render } from "./ATab.vue?vue&type=template&id=0ce60d66"
import script from "./ATab.vue?vue&type=script&lang=js"
export * from "./ATab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__